/* MD — add to bag without leaving the page: minimal drop-down confirmation.
   Copy and looks come from the Cart drawer section (#md-toast-config).
   Typography follows the sticky add-to-bag bar: name in the label typeface,
   price in whole units, size spelled out.
   Public API: window.MDCartToast.add(variantId, qty) → Promise, and .show(item). */
(function () {
  var DEFAULTS = {
    enabled: true,
    added: 'Added to your bag',
    view: 'View bag',
    checkout: 'Checkout',
    error: 'Something went wrong. Please try again.',
    showImage: true,
    showPrice: true,
    showVariant: true,
    duration: 5200,
    position: 'top',
    sizePrefix: 'Size',
    nameUppercase: true,
    css: {
      bg: 'rgba(62,44,28,.62)', text: '#f7f3ee', line: 'rgba(255,255,255,.16)',
      width: 420, radius: 0, blur: 22, imgSize: 52, imgBg: 'transparent', imgFit: 'contain',
      kickerSize: 9.5, nameSize: 13, nameTrack: 20, metaSize: 10, priceSize: 15, btnSize: 10,
      btnBg: '#f7f3ee', btnText: '#3e2c1c', uppercase: true
    }
  };

  function config() {
    var node = document.getElementById('md-toast-config');
    if (!node) return DEFAULTS;
    try {
      var raw = JSON.parse(String(node.textContent).replace(/,(\s*[\]}])/g, '$1'));
      var out = Object.assign({}, DEFAULTS, raw);
      out.css = Object.assign({}, DEFAULTS.css, raw.css || {});
      return out;
    } catch (e) { return DEFAULTS; }
  }

  var C = config();
  var root = window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/';
  var el, timer;

  function css() {
    var k = C.css;
    var caps = k.uppercase === false ? 'none' : 'uppercase';
    var mono = 'var(--mono,ui-monospace,Menlo,monospace)';
    var price = 'var(--price-font,var(--sans))';
    var nameTrack = ((k.nameTrack == null ? 20 : k.nameTrack) / 1000) + 'em';
    var closed, open, anchor;
    if (C.position === 'top-right') {
      anchor = 'top:14px;right:14px;left:auto';
      closed = 'translateY(-120%)'; open = 'translateY(0)';
    } else if (C.position === 'bottom-right') {
      anchor = 'bottom:14px;right:14px;left:auto;top:auto';
      closed = 'translateY(120%)'; open = 'translateY(0)';
    } else {
      anchor = 'top:0;left:50%';
      closed = 'translate(-50%,-120%)'; open = 'translate(-50%,0)';
    }
    var old = document.getElementById('md-toast-css');
    if (old) old.remove();
    var s = document.createElement('style');
    s.id = 'md-toast-css';
    s.textContent =
      '.md-toast{position:fixed;' + anchor + ';z-index:2147483600;transform:' + closed + ';' +
      'transition:transform .42s cubic-bezier(.22,.61,.36,1),opacity .3s ease;opacity:0;' +
      'width:min(' + k.width + 'px,calc(100vw - 24px));background:' + k.bg + ';color:' + k.text + ';' +
      (k.radius ? 'border-radius:' + k.radius + 'px;overflow:hidden;' : '') +
      '-webkit-backdrop-filter:blur(' + k.blur + 'px) saturate(140%);backdrop-filter:blur(' + k.blur + 'px) saturate(140%);' +
      'border:1px solid ' + k.line + ';' + (C.position === 'top' ? 'border-top:0;' : '') +
      'box-shadow:0 26px 70px rgba(35,24,14,.28);pointer-events:none}' +
      '.md-toast[data-open]{transform:' + open + ';opacity:1;pointer-events:auto}' +
      '.md-toast__in{display:grid;grid-template-columns:auto minmax(0,1fr);gap:14px;align-items:center;padding:14px 18px}' +
      '.md-toast__in[data-noimg]{grid-template-columns:minmax(0,1fr)}' +
      /* No frame around the photograph: it sits straight on the panel. */
      '.md-toast__img{width:' + k.imgSize + 'px;height:auto;aspect-ratio:1/1;object-fit:' + (k.imgFit || 'contain') + ';display:block;' +
      'background:' + (k.imgBg || 'transparent') + ';border:0;border-radius:' + (k.radius ? Math.min(k.radius, 8) : 0) + 'px;' +
      'mix-blend-mode:' + (k.imgBlend || 'normal') + '}' +
      '.md-toast__copy{display:flex;flex-direction:column;gap:4px;min-width:0}' +
      '.md-toast__kicker{font-family:' + mono + ';font-size:' + k.kickerSize + 'px;letter-spacing:.2em;text-transform:' + caps + ';opacity:.62}' +
      '.md-toast__name{font-family:' + mono + ';font-size:' + k.nameSize + 'px;line-height:1.3;letter-spacing:' + nameTrack + ';' +
      'text-transform:' + (C.nameUppercase === false ? 'none' : 'uppercase') + ';white-space:nowrap;overflow:hidden;text-overflow:ellipsis}' +
      '.md-toast__meta{display:flex;align-items:baseline;gap:9px;min-width:0}' +
      '.md-toast__meta:empty{display:none}' +
      '.md-toast__price{font-family:' + price + ';font-size:' + (k.priceSize || 15) + 'px;line-height:1.15;' +
      'font-variant-numeric:lining-nums tabular-nums;font-feature-settings:"lnum" 1,"tnum" 1}' +
      '.md-toast__size{font-family:' + mono + ';font-size:' + k.metaSize + 'px;letter-spacing:.1em;text-transform:uppercase;opacity:.6}' +
      '.md-toast__size:empty{display:none}' +
      '.md-toast__acts{display:flex;border-top:1px solid ' + k.line + '}' +
      '.md-toast__acts a{flex:1;text-align:center;padding:12px 10px;text-decoration:none;color:inherit;' +
      'font-family:' + mono + ';font-size:' + k.btnSize + 'px;letter-spacing:.16em;text-transform:' + caps + ';transition:background .2s,color .2s}' +
      '.md-toast__acts a:hover{background:rgba(255,255,255,.10)}' +
      '.md-toast__acts a + a{border-left:1px solid ' + k.line + ';background:' + k.btnBg + ';color:' + k.btnText + '}' +
      '.md-toast__acts a + a:hover{filter:brightness(1.06)}' +
      '@media (max-width:600px){.md-toast{width:calc(100vw - 16px)}}';
    (document.head || document.documentElement).appendChild(s);
  }

  function node() {
    if (el) return el;
    css();
    el = document.createElement('div');
    el.className = 'md-toast';
    el.setAttribute('role', 'status');
    el.innerHTML =
      '<div class="md-toast__in">' +
        '<img class="md-toast__img" alt="" hidden>' +
        '<div class="md-toast__copy">' +
          '<span class="md-toast__kicker"></span>' +
          '<span class="md-toast__name"></span>' +
          '<span class="md-toast__meta"><span class="md-toast__price"></span><span class="md-toast__size"></span></span>' +
        '</div>' +
      '</div>' +
      '<div class="md-toast__acts">' +
        '<a href="' + root + 'cart"></a>' +
        '<a href="' + root + 'checkout"></a>' +
      '</div>';
    document.body.appendChild(el);
    el.addEventListener('mouseenter', function () { clearTimeout(timer); });
    el.addEventListener('mouseleave', function () { hideLater(C.duration + 800); });
    return el;
  }

  function hideLater(ms) {
    clearTimeout(timer);
    timer = setTimeout(function () { if (el) el.removeAttribute('data-open'); }, ms || C.duration);
  }

  function show(item, error) {
    C = config();
    if (C.enabled === false) return;
    var t = node();
    css();
    var img = t.querySelector('.md-toast__img');
    var inner = t.querySelector('.md-toast__in');
    var acts = t.querySelectorAll('.md-toast__acts a');

    t.querySelector('.md-toast__kicker').textContent = error ? '' : C.added;
    t.querySelector('.md-toast__name').textContent = error ? C.error : (item && item.product_title || '');

    var priceEl = t.querySelector('.md-toast__price');
    var sizeEl = t.querySelector('.md-toast__size');
    priceEl.textContent = (!error && item && C.showPrice !== false && item.price != null) ? money(item.price) : '';
    var size = (!error && item && C.showVariant !== false && item.variant_title) ? String(item.variant_title).trim() : '';
    if (size === 'Default Title') size = '';
    sizeEl.textContent = size ? ((C.sizePrefix ? C.sizePrefix + ' ' : '') + size) : '';

    acts[0].textContent = C.view;
    acts[1].textContent = C.checkout;
    t.querySelector('.md-toast__acts').style.display = error ? 'none' : '';
    var withImage = !error && C.showImage !== false && item && item.image;
    if (withImage) { img.src = item.image.replace(/(\.[a-z]+)(\?|$)/i, '_200x$1$2'); img.hidden = false; inner.removeAttribute('data-noimg'); }
    else { img.hidden = true; inner.setAttribute('data-noimg', ''); }
    requestAnimationFrame(function () { t.setAttribute('data-open', ''); });
    hideLater(error ? 4000 : C.duration);
  }

  /* Whole units — the shop shows no decimals. */
  function money(cents) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      }).format(Math.round(cents / 100));
    } catch (e) { return String(Math.round(cents / 100)); }
  }

  function sync() {
    return fetch(root + 'cart.js').then(function (r) { return r.json(); }).then(function (c) {
      document.querySelectorAll('[data-cart-count],.cart-count,.header__cart-count').forEach(function (n) {
        n.textContent = c.item_count;
      });
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: c }));
      document.dispatchEvent(new CustomEvent('cart:build', { bubbles: true, detail: c }));
      return c;
    }).catch(function () {
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('cart:build', { bubbles: true }));
    });
  }

  function add(variantId, qty) {
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: qty || 1 }] })
    })
      .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw d; return d; }); })
      .then(function (data) {
        var item = data.items ? data.items[0] : data;
        show(item);
        return sync().then(function () { return item; });
      })
      .catch(function (err) { show(null, true); throw err; });
  }

  window.MDCartToast = { show: show, add: add, sync: sync };

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches('form[action*="/cart/add"]')) return;
    e.preventDefault();

    var btn = form.querySelector('[type="submit"]');
    var label = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: new FormData(form)
    })
      .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw d; return d; }); })
      .then(function (data) {
        var item = data.items ? data.items[0] : data;
        show(item);
        return sync();
      })
      .catch(function () { show(null, true); })
      .then(function () {
        if (btn) { btn.disabled = false; btn.textContent = label; }
      });
  }, true);
})();
